import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase, useServerPaginatedCollection } from "@/utils/stores/base";

const storeName = "rentalListingAgreement";

export const useRentalListingAgreementStore = defineStore(storeName, () => {
  const all = ref([]);

  const searchQuery = ref(null);
  const { baseFetchOne, baseFetchPage, baseMultipartSave, basePost, baseDelete, watchRemoteResourceChange } = useBase(storeName);

  const empty = {};

  const save = async (resource, callback, errorCallback) => {
    return await baseMultipartSave("rental-listing-agreements", resource, callback, errorCallback);
  };

  const {
    fetchAll,
    goToPage,
    goToNextPage,
    goToPreviousPage,
    currentPage,
    totalCount,
    totalPages,
    paginationRange
  } = useServerPaginatedCollection({
    resources: all,
    itemsPerPage: 10,
    searchQuery,
    fetchPage: async (errorCallback, includes, page, perPage, extraParams) => {
      return await baseFetchPage("rental-listing-agreements", errorCallback, includes, { page, perPage, extraParams });
    }
  });

  const fetchOne = async (id, errorCallback, includes = []) => {
    return await baseFetchOne("rental-listing-agreements", id, errorCallback, includes);
  };

  const buildReport = async (rentalListingAgreementId, callback, errorCallback, includes = []) => {
    const path = `rental-listing-agreements/${rentalListingAgreementId}/reports/rental-listing-agreements`;
    const params = {};
    if (includes && includes.length > 0) {
      params.include = Array.isArray(includes) ? includes.join(",") : includes;
    }
    return await basePost(path, {}, callback, errorCallback, params);
  };

  const deleteReport = async (rentalListingAgreementReportId, rentalListingAgreementId, callback, errorCallback) => {
    const path = `rental-listing-agreements/${rentalListingAgreementId}/reports/rental-listing-agreements`;
    return await baseDelete(path, rentalListingAgreementReportId, callback, errorCallback);
  };

  const watchResourceChanges = async (callback) => {
    await watchRemoteResourceChange(storeName, callback);
  };

  return {
    all,
    currentPage,
    empty,
    fetchAll,
    fetchOne,
    goToNextPage,
    goToPage,
    goToPreviousPage,
    paginated: all,
    paginationRange,
    save,
    searchQuery,
    sorted: all,
    totalCount,
    totalPages,
    buildReport,
    deleteReport,
    watchResourceChanges
  };
});
